export function capitalize(word: string | undefined): string {
    if (!word || word.length === 0) {
        return '';
    }
    const firstChar = word.charAt(0).toUpperCase();
    const rest = word.slice(1);
    return `${firstChar}${rest}`;
}

/*                                                */
export function removeFalsyValues(obj: Record<string, unknown>): Record<string, unknown> {
    return Object.fromEntries(Object.entries(obj).filter(([_, value]) => !!value));
}
